import { useState, useEffect } from "react";
import { useSettings } from "@/contexts/SettingsContext";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Loader, Calendar } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

export function BookingSettings() {
  const { bookingSettings, isUpdating, updateBookingSettings } = useSettings();
  const [enabled, setEnabled] = useState(bookingSettings?.enabled ?? false);
  const [disableProducts, setDisableProducts] = useState(
    bookingSettings?.disableProducts ?? false
  );

  useEffect(() => {
    setEnabled(bookingSettings?.enabled ?? false);
    setDisableProducts(bookingSettings?.disableProducts ?? false);
  }, [bookingSettings]);

  const handleSave = async () => {
    try {
      await updateBookingSettings({ enabled, disableProducts });
    } catch (error) {
      console.error("Error updating booking settings:", error);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label htmlFor="enable-bookings" >
            Enable Bookings
          </Label>
          <p className="text-sm text-muted-foreground">
            Allow customers to book services, rentals, or appointments through
            your storefront
          </p>
        </div>
        <Switch
          id="enable-bookings"
          checked={enabled}
          onCheckedChange={setEnabled}
          disabled={isUpdating}
        />
      </div>

      {enabled && (
        <>
          <Alert>
            <AlertDescription>
              When bookings are enabled, "Slots" and "Bookings" will appear in
              your dashboard sidebar. You can create booking slots for services
              like car hire, apartment rentals, hotel bookings, spa
              appointments, and more.
            </AlertDescription>
          </Alert>

          <div className="flex items-center justify-between pt-4">
            <div className="space-y-0.5">
              <Label htmlFor="disable-products" >
                Disable Products on Storefront
              </Label>
              <p className="text-sm text-muted-foreground">
                When enabled, products and the shopping cart will be hidden from
                your storefront. Only booking slots will be visible to
                customers.
              </p>
            </div>
            <Switch
              id="disable-products"
              checked={disableProducts}
              onCheckedChange={setDisableProducts}
              disabled={isUpdating}
            />
          </div>
        </>
      )}

      <div className="flex justify-end">
        <Button
          onClick={handleSave}
          size="sm"
          disabled={
            isUpdating ||
            (enabled === bookingSettings?.enabled &&
              disableProducts === bookingSettings?.disableProducts)
          }
          className="gap-2 !h-10"
        >
          {isUpdating && <Loader className="h-4 w-4 animate-spin" />}
          Save Changes
        </Button>
      </div>
    </div>
  );
}
